import Vue from "vue";

Vue.filter("dateFormat", value => {
  if (!value) return "";
  const date = new Date(value);
  return date.toLocaleDateString();
});

Vue.filter("uppercase", value => {
  if (!value) return "";
  value = value.toString();
  return value.toUpperCase();
});

Vue.filter("currency", value => {
  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR"
  }).format(value ? value : 0);
});

Vue.filter("vat", value => {
  if (!value) return "";
  value = value.toString().replace(".", ",") + " %";
  return value;
});
